import wixAnimations from 'wix-animations';
import { session } from 'wix-storage';
import wixLocation from 'wix-location';
import { searchInput, activateSearch } from 'public/search.js'

$w.onReady(function () {
    searchInput();
    activateSearch();
    fixViewerStickyBug();
});

// TEMP - Sticky cannot overight the desktop value//
function fixViewerStickyBug() {
    wixAnimations.timeline().add($w('#stickyMobileSearchSection'), { y: -21, duration: 0}).play();
}

//=====================
//       Search
//=====================
export function relevantSearchRepeater_itemReady($item, itemData) {
    let repeaterItem = $item('#searchRepeaterItem');
    repeaterItem.onClick(() => {
        session.setItem('page', "search");
        wixLocation.to(itemData.link);
    })
    repeaterItem.hide()
        .then(() => {
            $item('#searchRepeaterCategory').text = itemData.category;
            $item('#searchRepeaterTitle').text = itemData.title;
            itemData.relatedResult === true ?
                highlightDescription($item('#searchRepeaterDescription'), itemData.description) :
                $item('#searchRepeaterDescription').text = itemData.description;
            $item('#searchRepeaterCTA').link = itemData.link;
            if (itemData.type === 'Video Tutorial')
                $item('#searchRepeaterCTA').label = 'Watch video →';
            if (itemData.type === 'Lesson')
                $item('#searchRepeaterCTA').label = 'Start lesson →';
            if (itemData.type === 'From X Team')
                $item('#searchRepeaterCTA').label = 'Check it out →';
            if ('thumbnail' in itemData) {
                $item('#searchRepeaterImage').src = itemData.thumbnail;
                $item('#searchRepeaterImage').alt = itemData.altText;
            }
        });
    setTimeout(() => {
        wixAnimations.timeline()
            .add(repeaterItem, { y: -50, opacity: 0, duration: 0 })
            .add(repeaterItem, { y: 0, opacity: 1, duration: 500 })
            .play();
    }, 500);
}

async function highlightDescription(descriptionToHighlight, description) {
    let querystr = $w('#searchInput').value;
    let text = description;
    let reg = new RegExp(querystr, 'gi');
    let final_str = `<p>${text.replace(reg, str => { return '<strong style="color:#003DFF">' + str + '</strong>' })}</p>`
    descriptionToHighlight.html = final_str;
}

export function seeAllResultsButton_click() {
    const searchTerm = $w('#searchInput').value;
    wixLocation.to(`/search?q=${searchTerm}`);
}